import browserHistory from 'react-router/lib/browserHistory';
import { syncHistoryWithStore } from 'react-router-redux';
import ContainerApp from './app/containerApp';
import configureStore from './store';
import NotificationProvider from './app/common/NotificationProvider';

export const store = configureStore({}, browserHistory);
export const history = syncHistoryWithStore(browserHistory, store);
export const containerApp = ContainerApp(history);

export const Notifications = containerApp.isActive() ? containerApp.NotificationProvider : NotificationProvider;
